<template>
    <div class="w-full">
        <template v-if="datas.isUnique">
            <RouterLink :to="datas.path" class="link-btn">
                <component :is="datas.icon" class="icon" :size="20"/>
                <span class="text-2xl text-[#606675] font-light">{{ datas.label }}</span>
            </RouterLink>
        </template>
        <template v-else>
            <button @click="expand" :class="['px-[12px] cursor-pointer h-[36px] rounded-xl w-full flex items-center justify-between transition-colors border hover:bg-[#eff0fd] border-white hover:border-[#e2e5fc]',{'border-[#e2e5fc] bg-[#eff0fd]':isExpanded}]">
                <span class="flex items-center gap-x-[12px]">
                    <component :is="datas.icon" class="icon" :size="20"/>
                    <span class="text-2xl text-[#606675] font-light">{{ datas.label }}</span>
                </span>
                <Plus v-if="!isExpanded" color="#707071" :size="16"/>
                <Minus v-else color="#707071" :size="16"/>
            </button>
            <Transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
                <div class="py-[12px] pl-[22px] pr-[12px] w-full overflow-y-hidden" v-if="isExpanded">
                    <div class="px-[12px] w-full border-l flex flex-col gap-y-[4px]">
                        <RouterLink :to="value.path" v-for="(value,idx) in datas.subList" :key="idx" class="link-btn">
                            {{ value.label }}
                        </RouterLink>
                    </div>
                </div>
            </Transition>
        </template>
    </div>
</template>
<script>
import { RouterLink } from 'vue-router';
import { Plus, Minus } from 'lucide-vue-next';
import gsap from "gsap";
export default {
    name : "CustomNav",
    props:["datas"],
    components: {
        RouterLink,
        Plus, Minus
    },
    data(){
        return {
            isExpanded : false
        }
    },
    mounted(){
        const routePath = this.$route.fullPath;
        if(!this.datas.isUnique){
            for (let index = 0; index < this.datas.subList.length; index++) {
                const element = this.datas.subList[index].path;
                this.isExpanded = routePath.split('/').includes(element.slice(1));
                if(routePath.split('/').includes(element.slice(1))) return;
            }
        }
    },
    methods: {
        expand(){
            this.isExpanded = !this.isExpanded;
        },
        enter(el, done){
            gsap.to(el, {
                height: "auto",
                duration: 0.3,
                ease: "power2.inOut",
                onComplete: done,
            });
        },
        leave(el, done){
            gsap.to(el, {
                height: 0,
                duration: 0.3,
                ease: "power2.inOut",
                onComplete: done,
            });
        },
        beforeEnter(el){
            gsap.set(el, {
                height: 0,
            });
        },
    }
}
</script>